
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';

export default function ConfirmPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleEmailConfirmation = async () => {
      try {
        const token_hash = searchParams.get('token_hash');
        const type = searchParams.get('type');
        
        if (token_hash && type) {
          const { data, error } = await supabase.auth.verifyOtp({
            token_hash,
            type: type as any,
          });

          if (error) {
            console.error('Error confirming email:', error);
            setStatus('error');
            setMessage('Error al confirmar el email. El enlace puede haber expirado.');
          } else {
            setStatus('success');
            setMessage('¡Email confirmado exitosamente! Redirigiendo...');
            
            // Redirect to dashboard after 2 seconds
            setTimeout(() => {
              navigate('/dashboard');
            }, 2000);
          }
        } else {
          setStatus('error');
          setMessage('Enlace de confirmación inválido.');
        }
      } catch (error) {
        console.error('Error:', error);
        setStatus('error');
        setMessage('Ha ocurrido un error inesperado.');
      }
    };

    handleEmailConfirmation();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md text-center">
        {/* Logo */}
        <div className="w-20 h-20 mx-auto mb-4 relative">
          <img 
            src="/img/logo-sos.jpg"
            alt="S.O.S PADRES Logo"
            className="w-full h-full object-contain"
          />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2" style={{fontFamily: '"Pacifico", serif'}}>
          Agenda Padres Bebés
        </h1>
        <p className="text-sm text-gray-500 mb-8">de SOS Padres</p>

        {/* Status Content */}
        {status === 'loading' && (
          <div className="space-y-4">
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
            <h2 className="text-xl font-semibold text-gray-700">
              Confirmando tu email...
            </h2>
            <p className="text-gray-600">
              Por favor espera mientras verificamos tu cuenta.
            </p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center">
              <i className="ri-check-line text-3xl text-green-600"></i>
            </div>
            <h2 className="text-xl font-semibold text-green-700">
              ¡Email confirmado!
            </h2>
            <p className="text-gray-600">
              {message}
            </p>
            <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-green-600 text-sm">
              Tu cuenta ha sido activada exitosamente.
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <div className="w-16 h-16 mx-auto bg-red-100 rounded-full flex items-center justify-center">
              <i className="ri-close-line text-3xl text-red-600"></i>
            </div>
            <h2 className="text-xl font-semibold text-red-700">
              Error de confirmación
            </h2>
            <p className="text-gray-600">
              {message}
            </p>
            <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-red-600 text-sm">
              Intenta crear una cuenta nuevamente o contacta soporte.
            </div>
            <button
              onClick={() => navigate('/auth')}
              className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 px-4 rounded-xl font-medium hover:from-blue-600 hover:to-indigo-700 transition-all duration-200"
            >
              Volver al inicio de sesión
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
